// src/api/apiHotelMealPlans.js
import axios from "../utils/axios";

/// Get Hotel Meal Plans
export const getAllHotelMealPlans = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("hotel-meal-plans", { params });
    return data;
};

/// Get Hotel Meal Plan
export const getHotelMealPlan = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`hotel-meal-plans/${id}`);
    return data;
};

/// Create Hotel Meal Plan
export const createHotelMealPlan = async (req) => {
    try {
        const { data } = await axios.post("hotel-meal-plans", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createHotelMealPlan error:", error);
        throw error;
    }
};

/// Update Hotel Meal Plan
export const updateHotelMealPlan = async (req, id) => {
    try {
        const { data } = await axios.put(`hotel-meal-plans/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateHotelMealPlan error:", error);
        throw error;
    }
};

/// Delete Hotel Meal Plan
export const deleteHotelMealPlan = async (id) => {
    try {
        const { data } = await axios.delete(`hotel-meal-plans/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteHotelMealPlan error:", error);
        throw error;
    }
};

/// Delete All Hotel Meal Plans
export const deleteAllHotelMealPlans = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "hotel-meal-plans/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllHotelMealPlans error:", error);
        throw error;
    }
};

/// Restore Hotel Meal Plan
export const restoreHotelMealPlan = async (id) => {
    try {
        const { data } = await axios.post(`hotel-meal-plans/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreHotelMealPlan error:", error);
        throw error;
    }
};

/// Restore multiple Hotel Meal Plans
export const restoreAllHotelMealPlans = async (ids = []) => {
    try {
        const { data } = await axios.post(
            "hotel-meal-plans/mass-restore",
            { items: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllHotelMealPlans error:", error);
        throw error;
    }
};

/// Force Delete Hotel Meal Plan
export const forceDeleteHotelMealPlan = async (id) => {
    try {
        const { data } = await axios.delete(`hotel-meal-plans/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteHotelMealPlan error:", error);
        throw error;
    }
};

/// Force Delete multiple Hotel Meal Plans
export const forceDeleteAllHotelMealPlans = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "hotel-meal-plans/mass-force-delete",
            { data: { items: ids } },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllHotelMealPlans error:", error);
        throw error;
    }
};

/// Get Hotel Meal Plans for Select Dropdown
export const getHotelMealPlansForSelect = async () => {
    try {
        const { data } = await axios.get("hotel-meal-plans/for-select");
        return data;
    } catch (error) {
        console.error("getHotelMealPlansForSelect error:", error);
        throw error;
    }
};
